import useTools from "@/use/Tools.js";

export default function usePeriodicity() {

    const {$i18n} = useTools();

    const periodicity = [
        // {id: 'everyDay', name: $i18n.t('periodicity.EVERY_DAY')},
        {id: 'daily', name: $i18n.t('periodicity.DAILY')},
        {id: 'weekly', name: $i18n.t('periodicity.WEEKLY')},
        {id: 'monthly', name: $i18n.t('periodicity.MONTHLY')},
        {id: 'halfYearly', name: $i18n.t('periodicity.HALF_YEARLY')},
        {id: 'yearly', name: $i18n.t('periodicity.YEARLY')},
    ];

    const days = [
        {id: 'SATURDAY', name: $i18n.t('periodicity.SATURDAY')},
        {id: 'SUNDAY', name: $i18n.t('periodicity.SUNDAY')},
        {id: 'MONDAY', name: $i18n.t('periodicity.MONDAY')},
        {id: 'TUESDAY', name: $i18n.t('periodicity.TUESDAY')},
        {id: 'WEDNESDAY', name: $i18n.t('periodicity.WEDNESDAY')},
        {id: 'THURSDAY', name: $i18n.t('periodicity.THURSDAY')},
        {id: 'FRIDAY', name: $i18n.t('periodicity.FRIDAY')},
    ];

    const months = [
        {id: 'JANUARY', name: $i18n.t('periodicity.JANUARY')},
        {id: 'FEBRUARY', name: $i18n.t('periodicity.FEBRUARY')},
        {id: 'MARCH', name: $i18n.t('periodicity.MARCH')},
        {id: 'APRIL', name: $i18n.t('periodicity.APRIL')},
        {id: 'MAY', name: $i18n.t('periodicity.MAY')},
        {id: 'JUNE', name: $i18n.t('periodicity.JUNE')},
        {id: 'JULY', name: $i18n.t('periodicity.JULY')},
        {id: 'AUGUST', name: $i18n.t('periodicity.AUGUST')},
        {id: 'SEPTEMBER', name: $i18n.t('periodicity.SEPTEMBER')},
        {id: 'OCTOBER', name: $i18n.t('periodicity.OCTOBER')},
        {id: 'NOVEMBER', name: $i18n.t('periodicity.NOVEMBER')},
        {id: 'DECEMBER', name: $i18n.t('periodicity.DECEMBER')},
    ];

    const halfYearlyMonths = [
        {id: 1, name: $i18n.t('periodicity.JANUARY_JULY')},
        {id: 2, name: $i18n.t('periodicity.FEBRUARY_AUGUST')},
        {id: 3, name: $i18n.t('periodicity.MARCH_SEPTEMBER')},
        {id: 4, name: $i18n.t('periodicity.APRIL_OCTOBER')},
        {id: 5, name: $i18n.t('periodicity.MAY_NOVEMBER')},
        {id: 6, name: $i18n.t('periodicity.JUNE_DECEMBER')},
    ];

    const monthNumberDays = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];

    return {
        periodicity,
        days,
        months,
        halfYearlyMonths,
        monthNumberDays,
    }
}